import React, { useState } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { useStableCallback } from '@components-shared/src/hooks/useStableCallback';
import { Button } from '@components/main-components/button/Button';
import { ITEM_HEIGHT, QueueListItem } from './QueueListItem';

export const QueueListSection = ({
  activeTrackIndex,
  clearAll,
  deleteEnabled = false,
  heading,
  playing = false,
  scrollToTop,
  sectionStartingIndex,
  trackIds,
  scrollParent,
}: {
  activeTrackIndex: number;
  clearAll?: () => void;
  deleteEnabled?: boolean;
  heading: string;
  playing?: boolean;
  scrollToTop: () => void;
  sectionStartingIndex: number;
  trackIds: string[];
  scrollParent?: HTMLDivElement;
}) => {
  const [isScrolling, setIsScrolling] = useState(false);

  const renderQueueListItem = useStableCallback((sectionIndex: number, id: string) => (
    <QueueListItem
      activeTrackIndex={activeTrackIndex}
      deleteEnabled={deleteEnabled}
      key={`${heading}-${id}-${sectionStartingIndex + sectionIndex}}`}
      trackId={id}
      index={sectionStartingIndex + sectionIndex}
      playing={playing}
      scrollToTop={scrollToTop}
      isScrolling={isScrolling}
    />
  ));

  if (trackIds.length === 0) return null;

  return (
    <section className="[&:not(:first-of-type)]:mt-6">
      <div className="mb-4 flex">
        <h2 className="font-title text-title-m font-medium">{heading}</h2>
        {clearAll && (
          <Button
            size="XS"
            label="Clear All"
            onClick={clearAll}
            variant="text"
            className="ml-auto w-fit min-w-fit p-0 text-base600"
          />
        )}
      </div>
      <ul>
        <Virtuoso
          data={trackIds}
          itemContent={renderQueueListItem}
          fixedItemHeight={ITEM_HEIGHT}
          customScrollParent={scrollParent}
          isScrolling={setIsScrolling}
        />
      </ul>
    </section>
  );
};
